import { render, staticRenderFns } from "./performance.vue?vue&type=template&id=83ce2a46&scoped=true"
import script from "./performance.vue?vue&type=script&lang=js"
export * from "./performance.vue?vue&type=script&lang=js"
import style0 from "./performance.vue?vue&type=style&index=0&id=83ce2a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ce2a46",
  null
  
)

export default component.exports